import { css } from '@backyard-ui/styles';

const styles = css({
  display: 'inline-flex',
  flex: '0 0 auto',
  alignItems: 'center',
  justifyContent: 'center',

  minHeight: '$5',
  paddingX: '$2',

  overflow: 'hidden',
  boxSizing: 'border-box',

  fontSize: '$tsm',
  fontWeight: '$bold',

  textAlign: 'center',
  textOverflow: 'ellipsis',
  lineHeight: 1,

  borderRadius: '$xl',
  background: '$n100',

  cursor: 'default',
  userSelect: 'none',

  '.Backyard-Badge-inner': {
    paddingY: '$1',

    overflow: 'hidden',

    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  variants: {
    appearance: {
      critical: {
        color: '$white',
        background: '$c600',
      },
      info: {
        color: '$white',
        background: '$i800',
      },
      neutral: {
        color: '$white',
        background: '$n800',
      },
      primary: {
        color: '$white',
        background: '$p600',
      },
      success: {
        color: '$white',
        background: '$p600',
      },
      secondary: {
        color: '$white',
        background: '$s600',
      },
      tertiary: {
        color: '$white',
        background: '$t500',
      },
      warning: {
        color: '$n900',
        background: '$w500',
      },
    },

    variant: {
      solid: {},
      subtle: {},
    },

    icon: {
      true: {
        '.Backyard-Badge-icon': {
          display: 'flex',
          flexShrink: 0,

          marginRight: '$1',

          svg: {
            width: '$2',
            height: '$2',
          },
        },
      },
    },

    isFullWidth: {
      true: {
        width: '100%',
      },
    },
  },

  compoundVariants: [
    {
      appearance: 'critical',
      variant: 'subtle',
      css: {
        color: '$c800',
        background: '$c200',
      },
    },
    {
      appearance: 'info',
      variant: 'subtle',
      css: {
        color: '$i800',
        background: '$i200',
      },
    },
    {
      appearance: 'neutral',
      variant: 'subtle',
      css: {
        color: '$n900',
        background: '$n200',
      },
    },
    {
      appearance: 'primary',
      variant: 'subtle',
      css: {
        color: '$p800',
        background: '$p200',
      },
    },
    {
      appearance: 'secondary',
      variant: 'subtle',
      css: {
        color: '$s800',
        background: '$s200',
      },
    },
    {
      appearance: 'success',
      variant: 'subtle',
      css: {
        color: '$p800',
        background: '$p200',
      },
    },
    {
      appearance: 'tertiary',
      variant: 'subtle',
      css: {
        color: '$t700',
        background: '$t100',
      },
    },
    {
      appearance: 'warning',
      variant: 'subtle',
      css: {
        color: '$n900',
        background: '$w200',
      },
    },
  ],

  defaultVariants: {
    appearance: 'primary',
    variant: 'solid',
    isFullWidth: false,
  },
});

export default styles;
